import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DashboardComponent } from './components/DashboardComponent';

type Props = RouteComponentProps;

export const ClientDashboardContainer = (props: Props): JSX.Element => <DashboardComponent {...props} />;
